<template>
  <v-dialog
    v-model="model"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
    content-class="email-component-dialog-content"
  >
    <v-card
      v-bind:class="
        $vuetify.breakpoint.xsOnly
          ? 'vetalfa-view'
          : 'email-component-card-desktop vetalfa-view'
      "
      class="white vetalfa-padding-top-notch ma-0 pa-0"
      elevation="0"
      flat
    >
      <v-row justify="start" class="ma-0 pa-0">
        <v-btn
          @click="closeOrBack()"
          large
          :icon="step == 0"
          :text="step > 0"
          class="ma-0 pa-0 text-none"
        >
          <v-icon color="#393a3a">{{
            step == 0 ? mdiClose : mdiChevronLeft
          }}</v-icon>
          <span v-if="step > 0" class="pt-1">Voltar</span>
        </v-btn>
      </v-row>
      <v-row
        class="ma-0 pa-0 vetalfa-big-title"
        align="center"
        justify="center"
      >
        <v-col cols="8">
          <p class="ma-0 pa-0 text-center">
            {{ headerTitle }}
          </p>
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-0">
        <v-carousel
          touchless
          :cycle="false"
          hide-delimiter-background
          :show-arrows="false"
          hide-delimiters
          v-model="step"
        >
          <v-carousel-item v-for="i in 3" :key="i + 'step'">
            <v-sheet v-show="step == 0" color="white">
              <v-row align="start" justify="center" class="ma-0 pa-0">
                <v-col class="ma-0 pa-0" cols="10">
                  <p class="vetalfa-topic ma-0 pa-0">
                    {{ _getLabel("EMAIL_BODY_LOGIN") }}
                  </p>
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="center"
                class="ma-0 px-4 pb-0 pt-4 mt-4"
              >
                <v-col cols="10" class="ma-0 pa-0">
                  <v-text-field
                    light
                    dense
                    color="primary"
                    type="email"
                    outlined
                    :label="_getLabel('EMAIL_INPUT_LABEL')"
                    v-model="email"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="isNewUserLogin"
                align="center"
                justify="center"
                class="ma-0 px-4 mt-4 pt-2 py-0"
              >
                <v-col cols="10" class="ma-0 pa-0">
                  <v-text-field
                    light
                    dense
                    outlined
                    color="primary"
                    :label="_getLabel('EMAIL_INPUT_AGAIN_LABEL')"
                    v-model="emailInputConfirmation"
                    type="email"
                    :rules="[rules.matchingEmail]"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="isNewUserLogin"
                align="center"
                justify="center"
                class="ma-0 px-4 mt-4 pt-2 py-0"
              >
                <v-col cols="10" class="ma-0 pa-0">
                  <v-text-field
                    light
                    dense
                    color="primary"
                    outlined
                    :label="_getLabel('EMAIL_NEW_USER_NAME')"
                    v-model="name"
                    type="email"
                    :rules="[rules.required]"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center" justify="center" class="ma-0 mt-4 pa-4">
                <v-col class="ma-0 pa-0" cols="6">
                  <v-row class="ma-0 pa-0" justify="center">
                    <v-btn
                      light
                      class="primary text-none white--text"
                      @click="login()"
                      :loading="loading"
                    >
                      {{ _getLabel("CONTINUE") }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-sheet>
            <v-sheet
              v-show="step == 1 && (!hasPassword || !!forgotPassword)"
              color="white"
            >
              <v-row align="start" justify="center" class="ma-0 pa-0">
                <v-col class="ma-0 pa-0" cols="10">
                  <p class="vetalfa-topic ma-0 pa-0">
                    {{
                      `Para confirmar o cadastro da sua nova senha, enviaremos uma confirmação para o e-mail ${email}`
                    }}
                  </p>
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="center"
                class="ma-0 px-4 pb-0 pt-4 mt-4"
              >
                <v-col cols="10" class="ma-0 pa-0">
                  <v-text-field
                    light
                    :append-icon="showPassword ? mdiEye : mdiEyeOff"
                    @click:append="showPassword = !showPassword"
                    dense
                    hide-details
                    color="primary"
                    :type="showPassword ? 'text' : 'password'"
                    outlined
                    :label="_getLabel('EMAIL_INPUT_NEW_PASSWORD')"
                    v-model="password"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="center"
                class="ma-0 px-4 pa-0 mt-5 pt-5"
              >
                <v-col cols="10" class="ma-0 pa-0">
                  <v-text-field
                    light
                    :append-icon="showPassword ? mdiEye : mdiEyeOff"
                    @click:append="showPassword = !showPassword"
                    dense
                    color="primary"
                    :type="showPassword ? 'text' : 'password'"
                    outlined
                    :label="_getLabel('EMAIL_INPUT_AGAIN_PASSWORD')"
                    v-model="passwordConfirmation"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="center"
                class="ma-0 pa-4 mt-5 mb-2"
              >
                <v-col class="ma-0 pa-0" cols="12">
                  <v-row class="ma-0 pa-0" justify="center">
                    <v-btn
                      light
                      class="primary text-none white--text"
                      @click="registerPassword()"
                      :loading="loading"
                    >
                      Cadastrar senha
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col v-if="!forgotPassword" class="ma-0 pa-0 mt-7" cols="12">
                  <v-row class="ma-0 pa-0" justify="center">
                    <v-btn
                      text
                      class="primary--text text-none text-decoration-underline"
                      @click="jumpPassword()"
                      v-show="!loading"
                    >
                      Pular esta etapa
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-sheet>
            <v-sheet
              v-show="step == 1 && !!hasPassword && !forgotPassword"
              color="white"
            >
              <v-row align="start" justify="center" class="ma-0 pa-0">
                <v-col class="ma-0 pa-0" cols="10">
                  <p class="vetalfa-topic ma-0 pa-0">
                    Digite sua senha abaixo e clique em entrar.
                  </p>
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="center"
                class="ma-0 px-4 pb-0 pt-4 mt-4"
              >
                <v-col cols="10" class="ma-0 pa-0">
                  <v-text-field
                    light
                    :append-icon="showPassword ? mdiEye : mdiEyeOff"
                    @click:append="showPassword = !showPassword"
                    dense
                    hide-details
                    color="primary"
                    :type="showPassword ? 'text' : 'password'"
                    outlined
                    :label="_getLabel('EMAIL_INPUT_PASSWORD')"
                    v-model="password"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
                <v-col cols="10" class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0" align="start" justify="end">
                    <v-btn
                      @click="forgotPassword = true"
                      text
                      color="primary"
                      class="text-none text-decoration-underline pa-0 ma-0 mt-2"
                    >
                      Esqueci minha senha
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="center"
                class="ma-0 pa-4 mt-5 mb-2"
              >
                <v-col class="ma-0 pa-0 mt-12" cols="12">
                  <v-row class="ma-0 pa-0" justify="center">
                    <v-btn
                      light
                      class="primary text-none white--text"
                      @click="loginWithPasswordAsync()"
                      :loading="loading"
                    >
                      Entrar com senha
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col class="ma-0 pa-0 mt-7" cols="12">
                  <v-row class="ma-0 pa-0" justify="center">
                    <v-btn
                      text
                      class="primary--text text-none text-decoration-underline"
                      @click="jumpPassword()"
                      v-show="!loading"
                    >
                      Continuar sem senha
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-sheet>
            <v-sheet v-show="step == 2" color="white">
              <v-row align="start" justify="center" class="ma-0 pa-0">
                <v-col class="ma-0 pa-0" cols="10">
                  <p class="vetalfa-topic ma-0 pa-0">
                    Acesse o e-mail
                    <span class="font-weight-bold"> {{ email }} </span>
                    <span v-if="_isCordovaApp()"> e clique no botão </span>
                    para verificar sua conta.
                  </p>
                  <p class="vetalfa-topic ma-0 pa-0 mt-4">
                    <span v-if="_isCordovaApp()"> Se preferir, digite </span>
                    <span v-else> Digite </span> abaixo o código de 4 dígitos
                    recebido:
                  </p>
                </v-col>
              </v-row>
              <v-row align="center" justify="center" class="ma-0 pa-4 mt-2">
                <v-col class="ma-0 pa-0" cols="6">
                  <v-otp-input
                    v-model="code"
                    :disabled="loading"
                    v-bind:id="'numeric-email-code'"
                    type="number"
                    inputmode="decimal"
                    color="primary"
                    length="4"
                  ></v-otp-input>
                </v-col>
              </v-row>
              <v-row align="center" justify="center" class="ma-0 pa-4 my-2">
                <v-col class="ma-0 pa-0" cols="6">
                  <v-row class="ma-0 pa-0" justify="center">
                    <v-btn
                      light
                      class="primary text-none white--text"
                      @click="confirmEmailCodeAsync()"
                      :disabled="!isValidCode"
                      :loading="loading"
                    >
                      Verificar código
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider light class="mx-4"></v-divider>
              <v-row align="center" justify="center" class="ma-0 pa-0 mt-4">
                <v-col class="ma-0 pa-0" cols="6">
                  <v-row class="ma-0 pa-0" justify="center">
                    <v-btn
                      :disabled="loading"
                      light
                      v-if="!hasClickedResend"
                      text
                      class="primary--text text-none text-decoration-underline"
                      @click="resend()"
                    >
                      Não recebeu o e-mail? Clique aqui
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<style>
.email-component-card-desktop {
  height: 600px;
  width: 500px;
}
.email-component-dialog-content {
  max-width: 500px;
}
.email-component-text-field .v-label {
  right: 0 !important;
  text-align: center;
  left: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}
.email-component-text-field .v-label--active {
  transform: translateY(-20px) scale(1) !important;
}
.email-component-text-field input {
  text-align: center !important;
}
</style>

<script>
import { mdiChevronLeft, mdiClose, mdiEye, mdiEyeOff } from "@mdi/js";
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("general", ["user", "emailConfirmation"]),
    isValidCode() {
      if (!this.code && !this.code.trim()) {
        return false;
      }
      const numeric = new Number(this.code);
      return numeric >= 1000 && numeric <= 9999;
    },
    headerTitle() {
      if (this.step == 0) {
        return this._getLabel("EMAIL_HEADER_LOGIN");
      } else if (
        this.step == 1 &&
        (!this.hasPassword || !!this.forgotPassword)
      ) {
        return this._getLabel("EMAIL_HEADER_CREATE_PASSWORD");
      } else if (this.step == 1 && !!this.hasPassword && !this.forgotPassword) {
        return this._getLabel("EMAIL_HEADER_ENTER_PASSWORD");
      } else {
        return this._getLabel("EMAIL_HEADER_CONFIRM_EMAIL");
      }
    },
  },
  watch: {
    email(val) {
      this.email = (val || "").toLowerCase().trim();
      this.previousTimestamp = null;
      this.emailInputConfirmation = "";
      this.name = "";
      this.isNewUserLogin = false;
      this.forgotPassword = false;
      this.hasPassword = false;
      this.password = null;
      this.passwordConfirmation = null;
      this.createPassword = null;
    },
    step() {
      this.password = null;
      this.forgotPassword = false;
      this.passwordConfirmation = null;
      this.createPassword = null;
      this.code = "";
    },
    model(val) {
      this.setEmailConfirmation(val);
    },
  },
  methods: {
    ...mapActions("general", [
      "loginWithEmail",
      "confirmEmailCode",
      "showAlert",
      "showError",
      "logEvent",
      "getUserProvidersFromEmail",
      "routeRedirect",
      "loginWithPassword",
    ]),
    ...mapMutations("general", ["setConfirmModel", "setEmailConfirmation"]),
    closeOrBack() {
      if (this.step == 0) {
        this.logEvent("closeEmailConfirmation");
        this.model = false;
      } else if (this.step == 1 && !!this.forgotPassword) {
        this.forgotPassword = false;
      } else {
        this.step--;
      }
    },
    isValidPassword() {
      return (
        !this.password ||
        typeof this.password !== "string" ||
        this.password.length <= 5 ||
        this.password.length > 30 ||
        !this.password.match(/([0-9])/) ||
        !this.password.match(/([a-zA-Z])/) ||
        this.password.includes(" ")
      );
    },
    registerPassword() {
      if (this.isValidPassword()) {
        return this.showAlert({
          text: this._getMessage("INVALID_PASSWORD"),
          color: "black",
        });
      }
      if (this.password !== this.passwordConfirmation) {
        return this.showAlert({
          text: this._getMessage("INVALID_PASSWORD_CONFIRMATION"),
          color: "black",
        });
      }
      this.createPassword = this.password;
      this.loginWithEmailAsync();
    },
    login: async function () {
      try {
        this.loading = true;
        this.email = this.email.toLowerCase().trim();

        if (!this._isValidEmail(this.email)) {
          return this.showAlert({
            text: this._getMessage("INVALID_EMAIL"),
            color: "black",
          });
        }
        if (!this.isNewUserLogin) {
          const { providers, hasPassword } =
            await this.getUserProvidersFromEmail(this.email);
          this.hasPassword = hasPassword;
          if (providers.length == 0) {
            this.isNewUserLogin = true;
            return;
          }
        } else {
          if (this.email !== this.emailInputConfirmation.toLowerCase().trim()) {
            return this.showAlert({
              text: this._getMessage("INVALID_SECOND_EMAIL"),
              color: "black",
            });
          }
          if (!this._isValidFullName(this.name)) {
            return this.showAlert({
              text: this._getMessage("FULL_NAME_ERROR"),
              color: "black",
            });
          }
        }
        this.step = 1;
      } finally {
        this.loading = false;
      }
    },
    jumpPassword() {
      this.createPassword = null;
      this.loginWithEmailAsync();
    },
    loginWithPasswordAsync: async function () {
      if (this.isValidPassword()) {
        return this.showAlert({
          text: this._getMessage("INVALID_PASSWORD"),
          color: "black",
        });
      }
      this.loading = true;
      const response = await this.loginWithPassword({
        password: this.password,
        email: this.email,
      });
      this.model = !response;
      this.setEmailConfirmation(!response);
      this.loading = false;
      if (response) {
        this.routeRedirect({ name: "update" });
      }
    },
    loginWithEmailAsync: async function () {
      try {
        this.loading = true;
        this.email = this.email.toLowerCase().trim();
        if (this.previousTimestamp && !this.allowedTimeDifference()) {
          return this.showErrorTimeDifference();
        }
        const response = await this.loginWithEmail({
          email: this.email,
          name: this.name,
          password: this.createPassword || null,
        });
        if (response) {
          this.step = 2;
          this.previousTimestamp = this._getTimestamp();
        }
      } finally {
        this.loading = false;
      }
    },
    confirmEmailCodeAsync: async function () {
      this.loading = true;
      const response = await this.confirmEmailCode({
        code: this.code,
        email: this.email,
      });
      this.model = !response;
      this.setEmailConfirmation(!response);
      this.loading = false;
      if (response) {
        this.routeRedirect({ name: "update" });
      }
    },
    resend: async function () {
      if (!this.allowedTimeDifference()) {
        this.showErrorTimeDifference();
      } else {
        this.loading = true;
        const response = await this.loginWithEmail({
          email: this.email,
          name: this.name,
          retry: this._getTimestamp(),
          password: this.createPassword || null,
        });
        if (response) {
          this.previousTimestamp = this._getTimestamp();
          this.hasClickedResend = true;
          this.showAlert({
            text: this._getMessage("EMAIL_RESEND_CONFIRMATION"),
            color: "black",
          });
        }
        this.loading = false;
      }
    },
    allowedTimeDifference() {
      const timeDiff = (this._getTimestamp() - this.previousTimestamp) / 1000;
      return timeDiff > 20;
    },
    showErrorTimeDifference() {
      this.showAlert({
        text: this._getMessage("EMAIL_WAIT_RESEND"),
        color: "black",
      });
    },
  },
  data() {
    return {
      password: null,
      passwordConfirmation: null,
      createPassword: null,
      forgotPassword: false,
      hasPassword: false,
      showPassword: false,
      hasClickedResend: false,
      model: true,
      name: "",
      step: 0,
      email: "",
      emailInputConfirmation: "",
      isNewUserLogin: false,
      loading: false,
      code: "",
      previousTimestamp: null,
      mdiChevronLeft,
      regexFullName: /^[a-zA-Z]+ [a-zA-Z]+$/,
      mdiClose,
      mdiEye,
      mdiEyeOff,
      rules: {
        matchingEmail: (value) => {
          return (
            value == this.email || this._getMessage("INVALID_SECOND_EMAIL")
          );
        },
      },
    };
  },
};
</script>